module.exports = __webpack_public_path__ + "media/src/components/Navigation/NotificationHeader/img/brand-902fc4b548641764aeaaca2fcbdcae2a.png";